import AppShell from './app/AppShell';
import { AnalyticsConsent } from './components/AnalyticsConsent';
import { UpdateToast } from './components/UpdateToast';
import ShareImportGate from './features/share/ShareImportGate';
import { AppProviders } from './state/AppProviders';

export default function App() {
  return (
    <AppProviders>
      <AppShell />
      <ShareImportGate />
      <AnalyticsConsent />
      <UpdateToast />
    </AppProviders>
  );
}
